import * as React from "react";
import { Search, X } from "lucide-react";
import { Input } from "./input";
import { cn } from "@/lib/utils";

export interface SearchInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  onClear?: () => void;
}

export const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  ({ className, type, value, onClear, ...props }, ref) => {
    return (
      <div
        className={cn(
          "group flex items-center w-full h-8 p-2 bg-secondary-n-950 rounded-lg text-secondary-n-700 border border-secondary-n-950 transition-all",
          "group-focus-within:border-primary-0"
        )}
      >
        <Search className="size-5 text-secondary-n-700 transition-all group-focus-within:text-primary-0" />
        <Input
          placeholder="Search..."
          className={cn(
            "border-none focus-visible:ring-0 bg-transparent pl-2 text-xs text-white placeholder:text-secondary-n-700 rounded-md",
            className
          )}
          value={value}
          {...props}
          ref={ref}
          variant="search"
        />
        {value && onClear && (
          <X
            className="size-4 text-secondary-n-700 hover:text-white cursor-pointer"
            onClick={onClear}
          />
        )}
      </div>
    );
  }
);

SearchInput.displayName = "SearchInput";
